import * as React from 'react';
import { ClassName } from '../../utils/utils';

interface IContainerProps {
    type?: string;
    pd?: number;
    children: any;
}

const Container = (props: IContainerProps) => {
    const { type, pd } = props;
    return (
        <div className={ClassName('container', [type])}>
            <div className={pd ? `ps-${pd}` : ``}>
                {props.children}
            </div>
        </div>
    );
};

export default Container;



// WEBPACK FOOTER //
// ./src/modules/Container/Container.tsx